/* Task Report — fetches /api/report/task/data and renders KPIs, charts and the
   block → dated-entry accordion table. Generic: columns/kpis/charts come from the
   server (derived from each template's real capture_fields). */
if (window.location.pathname.startsWith("/report/task")) {
  (function () {
    const PALETTE = ['#10b981', '#3b82f6', '#a855f7', '#06b6d4', '#f59e0b', '#ec4899', '#14b8a6', '#f97316'];
    const SLATE = '#cbd5e1';
    const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const f0 = n => Math.round(+n || 0).toLocaleString();
    const f1 = n => (+n || 0).toLocaleString(undefined, { maximumFractionDigits: 1 });
    const f2 = n => (+n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const rm = n => 'RM ' + f0(n);
    const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, m => (
      { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
    const fdate = s => { const p = String(s || '').split('-'); return p.length === 3 ? (+p[2]) + ' ' + (MON[+p[1] - 1] || '') + ' ' + p[0] : (s || ''); };
    const fmtVal = (v, fmt) => {
      if (v === null || v === undefined || v === '') return '<span class="text-slate-300">—</span>';
      if (fmt === 'int') return f0(v);
      if (fmt === 'f1') return f1(v);
      if (fmt === 'f2') return f2(v);
      if (fmt === 'rm') return rm(v);
      return String(v);
    };
    // True when a KPI's rendered value is numerically zero (ignores '—', units, RM, commas).
    const isZeroKpi = k => {
      const t = String(k.value || '').replace(/<[^>]*>/g, '').replace(/,/g, '').trim();
      if (t === '' || t === '—') return false;
      const num = parseFloat(t.replace(/[^0-9.\-]/g, ''));
      return !isNaN(num) && num === 0;
    };
    const statusChip = s => s === 'completed'
      ? '<span class="chip bg-emerald-100 text-emerald-700">Completed</span>'
      : s === 'cancelled'
        ? '<span class="chip bg-slate-200 text-slate-600">Cancelled</span>'
        : s ? '<span class="chip bg-blue-100 text-blue-700">Active</span>' : '';

    let charts = [];
    const clearCharts = () => { charts.forEach(c => c.destroy()); charts = []; };
    let current = null;   // last payload (for CSV export)

    // Resolve a column's raw value for a row (block / entry / totals).
    function cellRaw(col, row) {
      switch (col.src) {
        case 'area_ha': return row.area_ha;
        case 'planted_ha': return row.planted_ha;
        case 'area_covered': return row.area_covered;
        case 'metric': return (row.metrics || {})[col.key];
        case 'text': return (row.metrics || {})[col.key];
        case 'cost': return (row.costs || {})[col.key];
        case 'derived': return (row.derived || {})[col.key];
        case 'estimate': return row.estimate;
        default: return null;
      }
    }
    // Rendered cell HTML for a column on a row.
    function cellHtml(col, row) {
      if (col.src === 'status') return statusChip(row.status);
      if (col.src === 'text') { const v = cellRaw(col, row); return v ? String(v) : '<span class="text-slate-300">—</span>'; }
      let html = fmtVal(cellRaw(col, row), col.fmt);
      if (col.strong) html = '<b>' + html + '</b>';
      return html;
    }
    function plainCell(col, row) {   // for CSV (no HTML)
      if (col.src === 'status') return row.status || '';
      const v = cellRaw(col, row);
      return (v === null || v === undefined) ? '' : String(v);
    }

    function render(p) {
      current = p;
      // Reveal the results area on first render (the page opens with just the filters).
      $('#tr-placeholder').addClass('hidden');
      $('#tr-results').removeClass('hidden');
      const cols = p.columns || [];
      const op = p.operation || {};
      $('#tr-tbl-title').text(op.name + ' — by block');
      const range = (p.from_date || '…') + ' → ' + (p.to_date || '…');
      $('#tr-note').html(
        '<i class="bi bi-info-circle"></i> ' + (p.log_count || 0) + ' daily entries · ' + range +
        (op.track_costs ? ' · costs from daily-log Labour/Material/Other.' : ' · this operation does not track costs.'));

      // KPIs
      $('#tr-kpis').html((p.kpis || []).map((k, i) => {
        // Area Covered (first) = orange · a zero value = red · everything else = green.
        const tone = i === 0 ? 'kpi-area' : (isZeroKpi(k) ? 'kpi-zero' : '');
        return `<div class="card ${tone} p-4"><div class="text-[11px] text-slate-400 uppercase">${k.label}</div>` +
          `<div class="text-2xl font-bold mt-1">${k.value}</div>` +
          `<div class="text-xs text-slate-400">${k.sub || ''}</div>` +
          (k.pct != null ? `<div class="bar mt-2"><span style="width:${k.pct}%"></span></div>` : '') +
          `</div>`;
      }).join(''));

      // Charts
      const cc = p.charts || [];
      $('#tr-charts').html(cc.map((c, i) =>
        `<div class="card p-5 ${cc.length === 1 ? 'lg:col-span-2' : ''}"><div class="font-semibold mb-3">${c.title}</div>` +
        `<canvas id="tr-ch${i}" height="${cc.length === 1 ? 90 : 150}"></canvas></div>`).join(''));
      clearCharts();
      cc.forEach((c, i) => {
        const el = document.getElementById('tr-ch' + i);
        if (!el || !window.Chart) return;
        // A chart may group its bars into stacks (e.g. Covered split per round):
        // datasets carrying the same `stack` sit on top of each other.
        const ds = c.datasets || [];
        const stacked = !!(c.stacked || ds.some(d => d.stack));
        // Datasets making up the stack the server flagged as the "real" total.
        const totalDs = ds.filter(d => d.stack === c.stack_total);
        const stackSum = idx => totalDs.reduce((sum, d) => sum + (+d.data[idx] || 0), 0);
        // Every bar is a quantity in c.y (ha / MT / RM) — always print the unit.
        const unit = v => f2(v) + (c.y ? ' ' + c.y : '');
        charts.push(new Chart(el, {
          type: 'bar',
          data: { labels: c.labels, datasets: ds.map((d, di) => ({
            label: d.label, data: d.data, borderRadius: 4, stack: d.stack || undefined,
            backgroundColor: di === 0 && (ds.length > 1) ? SLATE : PALETTE[di % PALETTE.length]
          })) },
          options: {
            plugins: {
              legend: { position: 'top', labels: { boxWidth: 12 } },
              tooltip: { callbacks: {
                label: it => ' ' + it.dataset.label + ': ' + unit(it.parsed.y),
                // Only worth a footer when the stack really is split across several bars.
                footer: items => {
                  if (!c.stack_total || !items.length) return '';
                  const idx = items[0].dataIndex;
                  const parts = totalDs.filter(d => (+d.data[idx] || 0) > 0).length;
                  return parts > 1 ? 'Total covered: ' + unit(stackSum(idx)) : '';
                }
              } }
            },
            scales: { x: { stacked: stacked }, y: { stacked: stacked, title: { display: true, text: c.y } } }
          }
        }));
      });

      // Table head
      $('#tr-thead').html(cols.map(c => `<th class="${c.align === 'l' ? 'l' : ''}">${c.label}</th>`).join(''));

      const blocks = p.blocks || [];
      $('#tr-empty').toggleClass('hidden', blocks.length > 0);

      // Body: a block row + its hidden dated-entry rows
      let html = '';
      blocks.forEach((b, i) => {
        const n = (b.entries || []).length;
        html += `<tr class="blk-row" data-i="${i}">` + cols.map((c, ci) => {
          if (ci === 0) {
            const chev = `<i class="bi bi-chevron-right chev mr-1 text-slate-400"></i>`;
            const tag = n ? `<span class="entry-tag">${n} ${n === 1 ? 'entry' : 'entries'}</span>` : '';
            return `<td class="l">${chev}<b>${b.name}</b>${tag}</td>`;
          }
          return `<td class="${c.align === 'l' ? 'l' : ''}">${cellHtml(c, b)}</td>`;
        }).join('') + `</tr>`;
        (b.entries || []).forEach(e => {
          html += `<tr class="sub sub-${i} hidden">` + cols.map((c, ci) => {
            if (ci === 0) {
              // date · sub-block · worker, then the round chip (ties the row to its
              // segment in the stacked Covered bar). Each part is dropped when empty
              // so the separators never dangle.
              const parts = [`<span class="e-date"><i class="bi bi-calendar3"></i>${fdate(e.date)}</span>`];
              if (e.area && e.area !== '—') parts.push(`<span class="text-slate-400">${esc(e.area)}</span>`);
              if (e.worker) parts.push(`<span class="e-worker">${esc(e.worker)}</span>`);
              const rnd = (e.round_no !== null && e.round_no !== undefined && e.round_no !== '')
                ? `<span class="e-round">R${e.round_no}</span>` : '';
              return `<td class="l"><span class="entry-label">${parts.join('<span class="e-sep">·</span>')}${rnd}</span></td>`;
            }
            // Total HA / Planted HA / Estimate are block-level static values — blank on per-entry rows.
            if (c.src === 'area_ha' || c.src === 'planted_ha' || c.src === 'estimate') return `<td><span class="text-slate-300">—</span></td>`;
            return `<td class="${c.align === 'l' ? 'l' : ''}">${cellHtml(c, e)}</td>`;
          }).join('') + `</tr>`;
        });
      });
      $('#tr-tbody').html(html);

      // Footer totals
      const t = p.totals || {};
      $('#tr-tfoot').html('<tr>' + cols.map((c, ci) => {
        if (ci === 0) return '<td class="l">TOTAL</td>';
        if (c.src === 'status') return '<td></td>';
        return `<td class="${c.align === 'l' ? 'l' : ''}">${cellHtml(c, t)}</td>`;
      }).join('') + '</tr>');
    }

    // Month filter mode: 'single' (one month) or 'range' (start → end month).
    let monthMode = 'single';
    function setMonthMode(mode) {
      monthMode = mode;
      const range = mode === 'range';
      $('#tr-month-mode button').each(function () {
        const on = $(this).data('mode') === mode;
        $(this).toggleClass('bg-emerald-50 text-emerald-700 font-medium', on)
               .toggleClass('bg-white text-slate-500', !on);
      });
      // Seed the end month with the start month the first time range mode opens.
      if (range && !$('#tr-month-to').val()) $('#tr-month-to').val($('#tr-month').val());
      $('#tr-mr-pop').addClass('hidden');
      mrSync();
    }

    // Month picker (both modes): one popover grid. Single mode: one click picks the month.
    // Range mode: first click = start, second = end, months in between are highlighted
    // as a continuous band (hover previews it).
    // Writes into #tr-month (start) / #tr-month-to (end), so fetchData is unchanged.
    const MR_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const mr = { start: '', end: '', picking: false, hover: '', year: new Date().getFullYear() };
    const mrPad = n => String(n).padStart(2, '0');
    const MR_FULL = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const mrFmt = (k, names = MR_NAMES) => k ? `${names[+k.slice(5, 7) - 1]} ${k.slice(0, 4)}` : '';

    function mrSync() {
      mr.start = $('#tr-month').val() || '';
      mr.end = (monthMode === 'range' && $('#tr-month-to').val()) || mr.start;
      mr.picking = false; mr.hover = '';
      $('#tr-mr-label').text(!mr.start ? 'Select month'
        : mr.start === mr.end ? mrFmt(mr.start, MR_FULL) : `${mrFmt(mr.start)} – ${mrFmt(mr.end)}`);
    }

    function mrRender() {
      let lo = mr.start, hi = mr.picking ? (mr.hover || mr.start) : mr.end;
      if (hi && lo && hi < lo) [lo, hi] = [hi, lo];
      $('#tr-mr-year').text(mr.year);
      $('#tr-mr-hint').text(monthMode !== 'range' ? 'Select month'
        : mr.picking ? 'Select end month' : 'Select start month');
      $('#tr-mr-grid').html(MR_NAMES.map((name, i) => {
        const key = `${mr.year}-${mrPad(i + 1)}`, col = i % 4;
        const inRange = lo && hi && key >= lo && key <= hi;
        const isEnd = key === lo || key === hi;
        let cell = 'h-9 cursor-pointer';
        if (inRange && lo !== hi) {
          cell += ' bg-emerald-100';
          if (key === lo || col === 0) cell += ' rounded-l-full';
          if (key === hi || col === 3) cell += ' rounded-r-full';
        }
        const lbl = isEnd ? 'bg-emerald-600 text-white font-semibold'
          : inRange ? 'text-emerald-800' : 'text-slate-600 hover:bg-slate-100';
        return `<div class="${cell}" data-key="${key}"><span class="block h-9 leading-9 text-center rounded-full text-sm ${lbl}">${name}</span></div>`;
      }).join(''));
    }

    function mrOpen() {
      mrSync();
      if (mr.start) mr.year = +mr.start.slice(0, 4);
      mrRender();
      $('#tr-mr-pop').removeClass('hidden');
    }

    function mrClose() {
      $('#tr-mr-pop').addClass('hidden');
      if (mr.picking) mrSync();   // abandoned half-picked range → keep the previous one
    }

    function mrPick(key) {
      if (monthMode !== 'range') {
        $('#tr-month').val(key);
        mrSync();
        return $('#tr-mr-pop').addClass('hidden');
      }
      if (!mr.picking) {
        mr.start = key; mr.end = ''; mr.hover = key; mr.picking = true;
        return mrRender();
      }
      const [a, b] = key < mr.start ? [key, mr.start] : [mr.start, key];
      $('#tr-month').val(a);
      $('#tr-month-to').val(b);
      mrSync();
      $('#tr-mr-pop').addClass('hidden');
    }

    function fetchData() {
      const tid = $('#tr-op').val();
      if (!tid) return;
      const data = {
        template_id: tid,
        month: $('#tr-month').val() || '',   // 'YYYY-MM' (start month in range mode)
      };
      if (monthMode === 'range') {
        const toMonth = $('#tr-month-to').val();
        if (data.month && toMonth && toMonth < data.month) {
          Toast.show('End month must be on or after the start month.', 'warning', 3000);
          return;
        }
        if (toMonth) data.to_month = toMonth;
      }
      const blk = $('#tr-block').val();
      if (blk) data.block_ids = blk;
      // Reveal results + show a loading state (page starts on the placeholder).
      $('#tr-placeholder').addClass('hidden');
      $('#tr-results').removeClass('hidden');
      $('#tr-tbody').html(`<tr><td colspan="20" class="l text-slate-400 py-6">Loading…</td></tr>`);
      $.ajax({ url: '/api/report/task/data', method: 'GET', data: data })
        .done(render)
        .fail(xhr => {
          $('#tr-tbody').empty();
          Toast.show('Failed to load report: ' + (xhr.responseJSON && xhr.responseJSON.error || xhr.statusText), 'error', 4000);
        });
    }

    // CSV export of the current payload (block rows + entries).
    // Styled, sectioned Excel export (title + period + KPI summary + full table).
    // Built as an HTML workbook so Excel/Sheets render headings, colours and borders —
    // and so the whole wide table is captured (no horizontal-scroll cut-off like print).
    function exportExcel() {
      if (!current) return;
      const cols = current.columns || [];
      const op = (current.operation && current.operation.name) || 'Report';
      const ncol = cols.length || 1;
      const kvCol = Math.max(1, ncol - 2);
      const range = (current.from_date || '…') + '  to  ' + (current.to_date || '…');
      const esc = s => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      const strip = s => String(s == null ? '' : s).replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
      const cellCls = (c, ci, base) => base + ((ci === 0 || c.align === 'l') ? 'L' : 'R');

      let h = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">' +
        '<head><meta charset="utf-8"><style>' +
        'table{border-collapse:collapse;font-family:Calibri,Arial,sans-serif;font-size:11pt}' +
        'td{border:0.5pt solid #cbd5e1;padding:4px 9px}' +
        '.title{font-size:16pt;font-weight:bold;color:#0f172a;border:none}' +
        '.meta{color:#475569;border:none}' +
        '.sec{font-weight:bold;color:#ffffff;background:#0f766e;text-align:left}' +
        '.hdr{font-weight:bold;color:#ffffff;background:#059669;text-align:center}' +
        '.kl{font-weight:bold;color:#334155;background:#f1f5f9;mso-number-format:"\\@"}' +
        '.kv{text-align:left;mso-number-format:"\\@"}' +
        '.blkL{font-weight:bold;background:#f8fafc;text-align:left;mso-number-format:"\\@"}' +
        '.blkR{font-weight:bold;background:#f8fafc;text-align:right}' +
        '.subL{color:#475569;text-align:left;mso-number-format:"\\@"}' +
        '.subR{color:#475569;text-align:right}' +
        '.totL{font-weight:bold;background:#dbeafe;text-align:left;mso-number-format:"\\@"}' +
        '.totR{font-weight:bold;background:#dbeafe;text-align:right}' +
        '</style></head><body><table>';

      // Title + period
      h += `<tr><td class="title" colspan="${ncol}">${esc(op)} — Task Report</td></tr>`;
      h += `<tr><td class="meta" colspan="${ncol}">Period: ${esc(range)}  ·  ${current.log_count || 0} daily entries</td></tr>`;
      h += `<tr><td colspan="${ncol}" style="border:none"></td></tr>`;

      // KPI summary (the top section)
      h += `<tr><td class="sec" colspan="${ncol}">Summary</td></tr>`;
      (current.kpis || []).forEach(k => {
        const val = strip(k.value) + (k.sub ? '  (' + strip(k.sub) + ')' : '');
        h += `<tr><td class="kl" colspan="2">${esc(k.label)}</td><td class="kv" colspan="${kvCol}">${esc(val)}</td></tr>`;
      });
      h += `<tr><td colspan="${ncol}" style="border:none"></td></tr>`;

      // Detail table (block → dated entries → total)
      h += `<tr><td class="sec" colspan="${ncol}">${esc(op)} — by block</td></tr>`;
      h += '<tr>' + cols.map(c => `<td class="hdr">${esc(c.label)}</td>`).join('') + '</tr>';
      (current.blocks || []).forEach(b => {
        h += '<tr>' + cols.map((c, ci) => {
          const v = ci === 0 ? b.name : (c.src === 'status' ? (b.status || '') : plainCell(c, b));
          return `<td class="${cellCls(c, ci, 'blk')}">${esc(v)}</td>`;
        }).join('') + '</tr>';
        (b.entries || []).forEach(e => {
          h += '<tr>' + cols.map((c, ci) => {
            let v;
            if (ci === 0) v = fdate(e.date) + (e.area && e.area !== '—' ? '  ·  ' + e.area : '');
            else if (c.src === 'area_ha' || c.src === 'planted_ha' || c.src === 'estimate') v = '';
            else if (c.src === 'status') v = e.status || '';
            else v = plainCell(c, e);
            return `<td class="${cellCls(c, ci, 'sub')}">${esc(v)}</td>`;
          }).join('') + '</tr>';
        });
      });
      const t = current.totals || {};
      h += '<tr>' + cols.map((c, ci) => {
        const v = ci === 0 ? 'TOTAL' : (c.src === 'status' ? '' : plainCell(c, t));
        return `<td class="${cellCls(c, ci, 'tot')}">${esc(v)}</td>`;
      }).join('') + '</tr>';
      h += '</table></body></html>';

      const blob = new Blob(['﻿' + h], { type: 'application/vnd.ms-excel' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'task-report-' + op.replace(/\s+/g, '-').toLowerCase() + (current.from_date ? '-' + current.from_date : '') + '.xls';
      a.click(); URL.revokeObjectURL(a.href);
    }

    $(function () {
      // Default to the current month.
      const now = new Date(), y = now.getFullYear(), pad = n => String(n).padStart(2, '0');
      $('#tr-month').val(`${y}-${pad(now.getMonth() + 1)}`);
      mrSync();
      $('#tr-month-mode').on('click', 'button', function () { setMonthMode($(this).data('mode')); });
      $('#tr-mr-btn').on('click', () => $('#tr-mr-pop').hasClass('hidden') ? mrOpen() : mrClose());
      $('#tr-mr-prev').on('click', () => { mr.year--; mrRender(); });
      $('#tr-mr-next').on('click', () => { mr.year++; mrRender(); });
      $('#tr-mr-grid')
        .on('click', '[data-key]', function () { mrPick($(this).attr('data-key')); })
        .on('mouseenter', '[data-key]', function () {
          const k = $(this).attr('data-key');
          if (mr.picking && k !== mr.hover) { mr.hover = k; mrRender(); }
        });
      $(document).on('mousedown', e => {
        if (!$(e.target).closest('#tr-month-to-wrap').length) mrClose();
      });
      $('#tr-apply').on('click', fetchData);
      $('#tr-csv').on('click', exportExcel);
      $('#tr-print').on('click', () => window.print());
      // Delegated accordion toggle (bound once): a block row expands its dated entries.
      $('#tr-tbody').on('click', '.blk-row', function () {
        const i = $(this).attr('data-i');
        $('.sub-' + i).toggleClass('hidden');
        $(this).find('.chev').toggleClass('open');
        $(this).toggleClass('open');
      });
      // No auto-load: the page opens on the filter; results appear only after Apply.
    });
  })();
}
